
export const toolkitCategories = ["All", "New Agent", "Company Wide", "Realty"];
export const toolkitTypes = ["All", "Team & Org Support", "Business Tools", "Win Clients", "Growth"];

export const toolkits = [
  {
    id: 1,
    title: "Agent State Resource Guide",
    description:
      "The Agent State Resource Guide provides streamlined access to state-specific resources, including meetings, training sessions, and compliance courses, ensuring agents remain aligned with regulatory requirements and continue to enhance their professional expertise.",
    image:
      "https://landing.exprealty.com/hubfs/Agent%20State%20Resource%20Guide%20-%20Toolkit%20Thumbnail.png",
    category: "New Agent",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/agent-resource-guide"
  },
  {
    id: 2,
    title: "Assistant Access",
    description:
      "The Assistant Access Program introduces a structured, tiered system for granting platform access to unlicensed assistants so they get access to the tools they need - no more, no less.",
    image:
      "https://landing.exprealty.com/hubfs/Assistant-Access_Toolkit-Thumbnail.png",
    category: "Company Wide",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/assistantaccess"
  },
  {
    id: 3,
    title: "Brand & Marketing",
    description:
      "You're the CEO of your business, and your brand should reflect the unique value you bring to the table. We give you the tools, support, and flexibility to create a brand that's authentically you.",
    image:
      "https://landing.exprealty.com/hubfs/Brand-Marketing_Toolkit-Thumbnail.png",
    category: "New Agent",
    type: "Business Tools",
    link: "https://exptoolkit.com/brand"
  },
  {
    id: 4,
    title: "Buyer Representation",
    description:
      "We're here to help you navigate compensation discussions smoothly, improve the buyer's experience, and position you as the go-to expert for ensuring buyer satisfaction.",
    image:
      "https://landing.exprealty.com/hubfs/Buyer-Representation_Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Win Clients",
    link: "https://exptoolkit.com/buyerrepresentation"
  },
  {
    id: 5,
    title: "Canva",
    description:
      "Elevate your marketing with stunning, customizable Canva templates designed exclusively for eXp agents. Create professional marketing materials including social media graphics and presentations.",
    image:
      "https://landing.exprealty.com/hubfs/Canva_Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Business Tools",
    link: "http://exptoolkit.com/canva"
  },
  {
    id: 6,
    title: "Co-Sponsor",
    description:
      "The eXp Co-Sponsor Program is designed to double the impact and support agents receive. This toolkit gives you everything you need to understand the program and step confidently into your role.",
    image:
      "https://landing.exprealty.com/hubfs/Co-Sponsor_Toolkit-Thumbnail.png",
    category: "New Agent",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/co-sponsor"
  },
  {
    id: 7,
    title: "CRM of Choice",
    description:
      "Your business, your tools. CRM of Choice is eXp's bold, new tech solution designed to put the power of freedom, flexibility, and control in your hands.",
    image:
      "https://landing.exprealty.com/hubfs/CRM-of-Choice_Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Business Tools",
    link: "https://exptoolkit.com/crmofchoice"
  },
  {
    id: 8,
    title: "Culture Centers",
    description:
      "If you have an office that sits underused, why not turn it into a revenue stream? By becoming a Culture Center host, you set the services, the pricing, and the rules.",
    image:
      "https://landing.exprealty.com/hubfs/Team%20Resource%20Guide%20-%20Toolkit%20Thumbnail%20(2)-1.png",
    category: "Realty",
    type: "Team & Org Support",
    link: "http://exptoolkit.com/culturecenters"
  },
  {
    id: 9,
    title: "Deed Fraud Protection",
    description:
      "Deed fraud is on the rise and it's targeting you and your clients. This toolkit equips you with the red flags, talking points, and resources to stop fraud before it starts.",
    image:
      "https://landing.exprealty.com/hubfs/Deed-fraud-protection_Toolkit-Thumbnail.png",
    category: "Company Wide",
    type: "Win Clients",
    link: "https://exptoolkit.com/deedfraud"
  },
  {
    id: 10,
    title: "eXp Commercial",
    description:
      "Your business. Your tools. Your future. From Co-Sponsor to Growth, Costar to RevShare — our Commercial-specific toolkits are built to help you scale smarter and faster.",
    image:
      "https://landing.exprealty.com/hubfs/Team%20Resource%20Guide%20-%20Toolkit%20Thumbnail%20(2)%20(1).png",
    category: "Company Wide",
    type: "Growth",
    link: "https://landing.expcommercial.com/toolkits?hsLang=en"
  },
  {
    id: 11,
    title: "eXp Pay",
    description:
      "Everything you need to know about sending and receiving payments at eXp Realty.",
    image:
      "https://landing.exprealty.com/hubfs/eXp-pay_Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Business Tools",
    link: "https://exptoolkit.com/exp-pay"
  },
  {
    id: 12,
    title: "Expert Care",
    description:
      "Your Expert Care Team is here when you need us - get fast, accurate support for every stage of your eXp journey including General Support, Premier Desk, Bilingual Desk & Agent Services.",
    image:
      "https://landing.exprealty.com/hubfs/Expert-Care_Toolkit-Thumbnail.png",
    category: "New Agent",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/expertcare"
  },
  {
    id: 13,
    title: "From Day One - Agent Compliance",
    description:
      "This toolkit makes it simple to stay informed, build trust, and grow with confidence. Inside, you'll find clear guidance, best practices, and quick-access resources to help you navigate compliance.",
    image:
      "https://landing.exprealty.com/hubfs/Team%20Resource%20Guide%20-%20Toolkit%20Thumbnail%20(1).jpg",
    category: "New Agent",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/fromdayone"
  },
  {
    id: 14,
    title: "Global Referral Program",
    description:
      "The Global Referral Toolkit makes it simple for eXp agents to connect across borders, create referral agreements in seconds, and unlock new business opportunities worldwide.",
    image:
      "https://landing.exprealty.com/hubfs/Global%20Referral.jpg",
    category: "New Agent",
    type: "Growth",
    link: "https://expinternationaltoolkit.com/global-referral-toolkit-agents"
  },
  {
    id: 15,
    title: "Growth & Attraction",
    description:
      "Need guidance on attracting agents? Looking to expand your team or brokerage? The Growth Toolkit equips you with resources and connects you to the experts to help you navigate your attraction efforts.",
    image:
      "https://landing.exprealty.com/hubfs/Growth-Attraction_Toolkit-Thumbnail.png",
    category: "New Agent",
    type: "Growth",
    link: "https://exptoolkit.com/growth"
  },
  {
    id: 16,
    title: "Growth & Attraction [Canada]",
    description:
      "The Growth Toolkit, tailored specifically for the Canadian market, equips you with resources and connects you to the experts to help you navigate your attraction efforts.",
    image:
      "https://landing.exprealty.com/hubfs/Growth%20Attraction%20-%20Toolkit%20Thumbnail.jpg",
    category: "Realty",
    type: "Growth",
    link: "https://exptoolkit.ca/growth"
  },
  {
    id: 17,
    title: "ICON Agent Award",
    description:
      "ICON agents and advisors are integral to eXp's culture, serving as role models, culture keepers, and a source of inspiration. Check out this toolkit for more information on how to achieve ICON status.",
    image:
      "https://landing.exprealty.com/hubfs/Icon-Agent-Award__Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/icon-agent-award"
  },
  {
    id: 18,
    title: "International Onboarding",
    description:
      "This toolkit is your go-to hub for joining or supporting eXp in any international country, with clear step-by-step processes and guidance at your fingertips.",
    image:
      "https://landing.exprealty.com/hubfs/International%20Onboarding.jpg",
    category: "Company Wide",
    type: "Team & Org Support",
    link: "https://expinternationaltoolkit.com/onboarding-toolkits"
  },
  {
    id: 19,
    title: "Land & Ranch",
    description:
      "The eXp Land & Ranch Toolkit has everything you need to explore the program, see the benefits, and learn how to become a member—built for agents who want to lead in land.",
    image:
      "https://landing.exprealty.com/hubfs/L%26R.jpg",
    category: "Realty",
    type: "Growth",
    link: "https://exptoolkit.com/landandranch"
  },
  {
    id: 20,
    title: "Lead Protection",
    description:
      "Protect your hard-earned leads and ensure you're compensated for your efforts. This toolkit provides clear guidelines, best practices, and essential resources for lead registration and dispute resolution.",
    image:
      "https://landing.exprealty.com/hubfs/Lead-Protection_Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Win Clients",
    link: "https://exptoolkit.com/leadprotection"
  },
  {
    id: 21,
    title: "Luxury Growth & Attraction",
    description:
      "The Luxury Growth & Attraction Toolkit provides everything you need to attract agents who are active in luxury or aspire to break into the luxury market.",
    image:
      "https://landing.exprealty.com/hubfs/Luxury%20Growth.jpg",
    category: "Realty",
    type: "Growth",
    link: "https://luxvt-demo.com/growth-attraction"
  },
  {
    id: 22,
    title: "Mentor Program",
    description:
      "Empower the next generation of agents through meaningful mentorship. This toolkit gives Certified Mentors the tools to lead with confidence.",
    image:
      "https://landing.exprealty.com/hubfs/Mentor-Program_Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/mentorship"
  },
  {
    id: 23,
    title: "New eXp Agent",
    description:
      "Start strong at eXp with resources designed to set you up for success. Watch a welcome message from CEO Leo Pareja, dive into Quick Start training, and access all eXp toolkits.",
    image:
      "https://landing.exprealty.com/hubfs/Team%20Resource%20Guide%20-%20Toolkit%20Thumbnail%20(2).png",
    category: "New Agent",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/us-new-exp-agent"
  },
  {
    id: 24,
    title: "Onboarding",
    description:
      "Your step-by-step guide to joining eXp. From pre-onboarding to activation, you'll find everything you need—application roadmaps, resource videos, and state-specific guides.",
    image:
      "https://landing.exprealty.com/hubfs/Team%20Resource%20Guide%20-%20Toolkit%20Thumbnail.png",
    category: "New Agent",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/us-realty-onboarding"
  },
  {
    id: 25,
    title: "ONE eXp",
    description:
      "ONE eXp is a global community of over 50k agents and staff, united by purpose and driven by connection. Explore our 16+ resource groups and join the movement today.",
    image:
      "https://landing.exprealty.com/hubfs/Team%20Resource%20Guide%20-%20Toolkit%20Thumbnail-1.png",
    category: "Realty",
    type: "Growth",
    link: "http://exptoolkit.com/oneexp"
  },
  {
    id: 26,
    title: "Rev Share",
    description:
      "Maximize your earning potential with a streamlined approach to building your revenue share organization. This toolkit includes communication templates and goal-setting guides.",
    image:
      "https://landing.exprealty.com/hubfs/Revenue-Share_Toolkit-Thumbnail.png",
    category: "New Agent",
    type: "Growth",
    link: "https://exptoolkit.com/revenueshare"
  },
  {
    id: 27,
    title: "Seller Toolkit",
    description:
      "We've got your back and will navigate the changes together. We're here to make this transition smooth and straightforward for both you and your seller clients.",
    image:
      "https://landing.exprealty.com/hubfs/Seller_Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Win Clients",
    link: "https://exptoolkit.com/sellers"
  },
  {
    id: 28,
    title: "Slack",
    description:
      "Slack is now your new home for real-time conversations, updates and collaboration at eXp—use this toolkit to get started and make the most of it.",
    image:
      "https://landing.exprealty.com/hubfs/Slack_Toolkit-Thumbnail.png",
    category: "Company Wide",
    type: "Business Tools",
    link: "https://exptoolkit.com/slack"
  },
  {
    id: 29,
    title: "Sponsorship & Retention",
    description:
      "Build strong relationships and long-term success by supporting your team effectively. This toolkit equips sponsors with training materials and communication strategies.",
    image:
      "https://landing.exprealty.com/hubfs/Sponsorship-Retention_Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Growth",
    link: "https://exptoolkit.com/sponsorship"
  },
  {
    id: 30,
    title: "Sponsorship & Retention [Canada]",
    description:
      "Build strong relationships and long-term success by supporting your team effectively. This toolkit, specific to sponsorship and retention in Canada, equips sponsors with training materials.",
    image:
      "https://landing.exprealty.com/hubfs/Sponsorship%20Retention%20-%20Toolkit%20Thumbnail.jpg",
    category: "Realty",
    type: "Growth",
    link: "https://exptoolkit.ca/sponsorship"
  },
  {
    id: 31,
    title: "Team Leader Academy",
    description:
      "For team leaders ready to grow and scale, this toolkit is your go-to hub for everything Team Leader Academy—featuring upcoming cohorts, essential resources, and actionable guides.",
    image:
      "https://landing.exprealty.com/hubfs/Team%20Leader%20Academy%20-%20Toolkit%20Thumbnail.png",
    category: "Company Wide",
    type: "Growth",
    link: "https://exptoolkit.com/teamleaderacademy"
  },
  {
    id: 32,
    title: "Team Resource Guide",
    description:
      "Starting or growing a team at eXp? The Teams Toolkit has the resources and support you need to build, lead, and scale with confidence. From structure to onboarding, it's all here.",
    image:
      "https://landing.exprealty.com/hubfs/Team-Resource-Guide_Toolkit-Thumbnail.png",
    category: "Realty",
    type: "Team & Org Support",
    link: "https://exptoolkit.com/teams"
  }
];
